/* ============================================================
   Global Anima Button Enhancer
   Turns a normal <a class="anima-btn">SHOP NOW</a> or
   <button class="anima-btn">SHOP NOW</button> into the animated markup.
   ============================================================ */

(function(){
  const SVG_PATH = 'M7 17L17 7M17 7H9M17 7V15';

  function getButtonText(el){
    const explicitText = el.getAttribute('data-anima-text');
    if (explicitText && explicitText.trim()) return explicitText.trim();

    const text = el.textContent.replace(/\s+/g, ' ').trim();
    return text || 'SHOP NOW';
  }

  function createArrow(className){
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('class', 'anima-btn__arrow ' + className);
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');

    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', SVG_PATH);
    path.setAttribute('fill', 'none');
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-width', '2');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('stroke-linejoin', 'round');

    svg.appendChild(path);
    return svg;
  }

  function enhanceButton(el){
    if (!el || el.dataset.animaReady === 'true') return;

    const tagName = el.tagName ? el.tagName.toLowerCase() : '';
    if (tagName !== 'a' && tagName !== 'button') return;

    if (el.querySelector('.anima-btn__text') && el.querySelector('.anima-btn__icon')) {
      el.dataset.animaReady = 'true';
      return;
    }

    const text = getButtonText(el);

    if (!el.getAttribute('aria-label')) {
      el.setAttribute('aria-label', text);
    }

    el.textContent = '';

    const bg = document.createElement('span');
    bg.className = 'anima-btn__bg';
    bg.setAttribute('aria-hidden', 'true');

    const textSpan = document.createElement('span');
    textSpan.className = 'anima-btn__text';
    textSpan.textContent = text;

    const icon = document.createElement('span');
    icon.className = 'anima-btn__icon';
    icon.setAttribute('aria-hidden', 'true');

    icon.appendChild(createArrow('anima-btn__arrow--current'));
    icon.appendChild(createArrow('anima-btn__arrow--next'));

    el.appendChild(bg);
    el.appendChild(textSpan);
    el.appendChild(icon);

    el.dataset.animaReady = 'true';
  }

  function initAnimaButtons(scope){
    const root = scope || document;
    root.querySelectorAll('.anima-btn').forEach(enhanceButton);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){
      initAnimaButtons(document);
    });
  } else {
    initAnimaButtons(document);
  }

  window.AnimaButton = window.AnimaButton || {};
  window.AnimaButton.init = initAnimaButtons;

  if ('MutationObserver' in window) {
    const observer = new MutationObserver(function(mutations){
      mutations.forEach(function(mutation){
        mutation.addedNodes.forEach(function(node){
          if (!node || node.nodeType !== 1) return;

          if (node.matches && node.matches('.anima-btn')) {
            enhanceButton(node);
          }

          if (node.querySelectorAll) {
            initAnimaButtons(node);
          }
        });
      });
    });

    observer.observe(document.documentElement, {
      childList:true,
      subtree:true
    });
  }
})();
